import { FC } from "react";
import { AsideMenuMain } from "./aside-menu-main";

export const AsideMenu: FC = () => {
  return (
    <div
      id="kt_aside_menu_wrapper"
      className="hover-scroll-overlay-y my-5 my-lg-5"
      data-kt-scroll="true"
      data-kt-scroll-activate="{default: false, lg: true}"
      data-kt-scroll-height="auto"
      data-kt-scroll-dependencies="#kt_aside_logo, #kt_aside_footer"
      data-kt-scroll-wrappers="#kt_aside_menu"
      data-kt-scroll-offset="0"
    >
      <div
        id="#kt_aside_menu"
        data-kt-menu="true"
        className={`menu
                    menu-column
                    menu-title-gray-800
                    menu-state-title-primary
                    menu-state-icon-primary
                    menu-state-bullet-primary
                    menu-arrow-gray-500`}>
        <AsideMenuMain />
      </div>
    </div>
  );
};
